import axios from "axios";

export const getNotifications = async (page, stock) => {
    const params = stock && page ? { page, tradingitem_id: stock } : stock ? { tradingitem_id: stock } : page ? { page } : {};

    const res = await axios.get("/interface/api/notifications", {
        params,
    });

    return res.data;
};

export const notificationsViewed = async (id: number) => {
    const res = await axios.post(`/interface/api/notifications/${id}`);

    return res;
};
